/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signedinas2Inputs */

const en_signedinas2 = /** @type {(inputs: Signedinas2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Signed in as`)
};

const de_signedinas2 = /** @type {(inputs: Signedinas2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Angemeldet als`)
};

/**
* | output |
* | --- |
* | "Signed in as" |
*
* @param {Signedinas2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const signedinas2 = /** @type {((inputs?: Signedinas2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signedinas2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_signedinas2(inputs)
	return de_signedinas2(inputs)
});
export { signedinas2 as "signedInAs" }